module.exports = __webpack_public_path__ + "img/Untitled-21.4e4959ba.png";